import React from 'react';
import AntConfigProvider from 'antd-core/es/config-provider';
import { Language } from '@10d/tend-ui-locale';
import { Theme as Theme$1 } from '@10d/tend-ui-theme';
import { css, createGlobalStyle } from 'styled-components';
import { createAntdTheme } from './utils.js';
import { Language as Language$1 } from '../locale/Language.js';
import { SamoletTheme } from './SamoletTheme.js';
import { ConfigProvider } from './ConfigProvider.js';
import { Theme } from './Theme.js';

const styles = css `
  /* Menu */
  .tend-ui-menu-submenu-popup .tend-ui-menu-vertical.tend-ui-menu-sub {
    padding: 8px 0;
  }

  /* Dialog */
  .tend-ui-modal-confirm {
    &.tend-ui-modal-confirm-image {
      .tend-ui-modal-confirm-body {
        flex-direction: column;
        align-items: center;

        & > .anticon {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 24px;
          margin-inline-end: 0px;
          font-size: 48px;
          border-radius: 50%;
          width: 80px;
          height: 80px;
        }
      }
    }
    &.tend-ui-modal-confirm-image-cover {
      .tend-ui-modal-content {
        padding: 0px;
      }
      .tend-ui-modal-confirm-paragraph {
        padding: 0 32px;
      }
    }
    &.tend-ui-modal-confirm-info,
    &.tend-ui-modal-confirm-success,
    &.tend-ui-modal-confirm-warning,
    &.tend-ui-modal-confirm-error {
      .tend-ui-modal-confirm-title {
        margin-top: 12px;
      }
      .tend-ui-modal-confirm-body {
        & > .anticon {
          font-size: 40px;
        }
      }
    }

    .tend-ui-modal-confirm-paragraph {
      gap: 12px;
    }
  }
`;
const GlobalStyles = createGlobalStyle `${styles}`;
const TendUI = ({ lang = 'ru', theme = 'samolet', children, }) => {
    return (React.createElement(Theme, { theme: theme },
        React.createElement(Theme$1, { theme: theme },
            React.createElement(GlobalStyles, null),
            React.createElement(Language, { language: lang },
                React.createElement(Language$1, { language: lang },
                    React.createElement(ConfigProvider, null, children))))));
};
TendUI.init = (theme = SamoletTheme) => {
    AntConfigProvider.config({
        prefixCls: 'tend-ui',
        theme: createAntdTheme(theme),
    });
};

export { TendUI };
//# sourceMappingURL=TendUI.js.map
